import { useDatabase } from "@nozbe/watermelondb/hooks";
import React from "react";
import {
  FlatActionList,
  FlatActionListItem,
  Page,
  PayTypeToIcon,
  Stack,
  Text,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { useFormContext } from "react-hook-form";
import { Feather } from "@expo/vector-icons";
import { StackScreenProps } from "@react-navigation/stack";
import PayType from "../../../../utilities/data/model/PayType";
import { useTranslation } from "react-i18next";
import { Q } from "@nozbe/watermelondb";
import { View } from "react-native-ui-lib";
import spacingInstance from "react-native-ui-lib/src/style/spacings";

export type SelectPaymentTypeScreenProps = StackScreenProps<
  any,
  "SelectPaymentTypeScreen"
>;

export const SelectPaymentTypeScreen = ({
  navigation,
}: SelectPaymentTypeScreenProps) => {
  const { t } = useTranslation("settings");
  const database = useDatabase();
  const [payTypes, setPayTypes] = React.useState<PayType[] | undefined>();
  const { watch, setValue } = useFormContext<{
    payTypeId: string;
  }>();
  const { colors } = useThemeProvider();

  const watchedPayTypeId = watch("payTypeId");

  React.useEffect(() => {
    database
      .get<PayType>("pay_types")
      .query(
        Q.where("internal", Q.eq(false)),
        Q.where("deleted_at", Q.eq(null))
      )
      .fetch()
      .then((l) => setPayTypes(l));
  }, []);

  const handleOnSelect = React.useCallback((payTypeId: string) => {
    setValue("payTypeId", payTypeId, {
      shouldValidate: true,
      shouldDirty: true,
    });
    navigation.goBack();
  }, []);

  const items: FlatActionListItem[] = React.useMemo(() => {
    return (
      payTypes?.map((payType) => {
        return {
          key: payType.id,

          titleContent: ({ title }) => {
            return (
              <View row centerV>
                <View style={{ paddingRight: spacingInstance.s4 }}>
                  <PayTypeToIcon payType={payType.id} />
                </View>
                <Stack spacing={1} vertical>
                  <Stack spacing={spacingInstance.s1} vertical centerHorizontal>
                    {title}
                    <Text color="subdued">{payType.description}</Text>
                  </Stack>
                </Stack>
              </View>
            );
          },

          title: payType.name,
          secondaryTitle: payType.description,
          onPress: () => handleOnSelect(payType.id),
          componentRight: (icon) => {
            return watchedPayTypeId == payType.id ? (
              <Feather name="check" size={24} color={colors.primary} />
            ) : (
              icon
            );
          },
        };
      }) || []
    );
  }, [payTypes, watchedPayTypeId, handleOnSelect]);

  return (
    <Page title={t("modal_select_paytype_title")}>
      <FlatActionList items={items} />
    </Page>
  );
};
